export default __webpack_public_path__ + "static/media/repeat.5351d75d.svg";